/**
 * Apply / refresh html.naturals-touch-shell for CSS hooks in WebViews.
 * Safe to call once at app bootstrap or from page shells.
 */
import { SHELL_MQ } from './tabletMedia';

const SHELL_CLASS = 'naturals-touch-shell';

export function bindNaturalsTouchShellClass(win = typeof window !== 'undefined' ? window : null) {
  if (!win?.matchMedia || !win.document?.documentElement) {
    return () => {};
  }

  const root = win.document.documentElement;
  const mq = win.matchMedia(SHELL_MQ);

  const apply = () => {
    root.classList.toggle(SHELL_CLASS, mq.matches);
  };

  apply();
  mq.addEventListener('change', apply);
  return () => {
    mq.removeEventListener('change', apply);
    root.classList.remove(SHELL_CLASS);
  };
}
